export default "<p-toast key=\"tst\"></p-toast>\n<router-outlet></router-outlet>";